<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Icoontje"
      type="text"
      :value="modelValue.icon"
      @input="(value) => update('icon', value)"
      :name="`components[${index}][icon]`"
    />

    <FormKit
      label="Type"
      type="select"
      :value="modelValue.type"
      @input="(value) => update('type', value)"
      :options="types"
      :name="`components[${index}][type]`"
    />

    <FormKit
      label="Titel"
      type="text"
      :value="modelValue.title"
      @input="(value) => update('title', value)"
      :name="`components[${index}][title]`"
    />

    <FormKit
      label="Omschrijving"
      type="textarea"
      :value="modelValue.message"
      @input="(value) => update('message', value)"
      :name="`components[${index}][message]`"
    />
  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  mixins: [mixin],
  data() {
    return {
      types: [
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "light",
        "dark",
      ],
    };
  },
};
</script>